import { Component } from '@angular/core';

@Component({
  selector: 'app-device-redirectLink',
  templateUrl: './device-redirectLink.component.html',
  styleUrls: ['./device-redirectLink.component.scss']
})
export class DeviceRedirectLink{

}

